module.exports = __webpack_public_path__ + "static/dog-l-898243b4d4e4c2acd782eba0bd475b58.jpg";